import { createFileRoute, Link, Outlet } from '@tanstack/react-router';
import { HelpSearch } from '../components/help/help-search';
import { topicTree } from '../lib/help/articles';
import { useCustomArticles } from '../lib/help/custom';
import { useRole } from '../lib/session';

export const Route = createFileRoute('/onboarding')({ component: OnboardingLayout });

/** Topic tree left, article center, outline right, search on top (PLAN §12.6). */
function OnboardingLayout() {
  const tree = topicTree(useRole(), useCustomArticles());
  return (
    <div className="-m-6 grid min-h-full grid-cols-[15rem_1fr]">
      <nav aria-label="Help topics" className="border-e bg-surface p-4">
        <Link to="/onboarding" activeOptions={{ exact: true }} className="mb-3 block text-sm font-semibold data-[status=active]:underline">
          Onboarding
        </Link>
        {tree.map(c => (
          <div key={c.key} className="mb-4">
            <h2 className="mb-1 text-xs font-semibold text-muted-foreground uppercase">{c.label}</h2>
            <ul className="space-y-0.5">
              {c.articles.map(a => (
                <li key={a.slug}>
                  <Link
                    to="/onboarding/$slug"
                    params={{ slug: a.slug }}
                    className="block rounded px-2 py-1 text-sm text-muted-foreground hover:bg-muted hover:text-foreground data-[status=active]:bg-muted data-[status=active]:font-medium data-[status=active]:text-foreground"
                  >
                    {a.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>
      <div className="min-w-0 p-6">
        <div className="mb-6 max-w-xl">
          <HelpSearch />
        </div>
        <Outlet />
      </div>
    </div>
  );
}
